//STORE
export const GET_BANKS = 'getBanks'
export const CREATE_BANK = 'createBank'
export const DELETE_BANK = 'deleteBank'
export const UPDATE_BANK = 'updateBank'

//COMPANY
export const GET_COMPANY_BANKS = 'getCompanyBanks'
export const CREATE_COMPANY_BANK = 'createCompanyBank'
export const DELETE_COMPANY_BANK = 'deleteCompanyBank'
export const UPDATE_COMPANY_BANK = 'updateCompanyBank'